<script lang="ts">
  export let imageLink: string
  export let selfEmployed: boolean = false
</script>

<div class="image-overlay">
  {#if imageLink}
    <div class="image" style="background-image: url({imageLink});"></div>
  {:else}
    <div class="image-empty"></div>
  {/if}
  {#if selfEmployed}
    <div class="image-badge" style="background-image: url('svg/self-employed.svg')"></div>
  {/if}
</div>

<style>
  .image-overlay {
    width: 100%;
    height: 220px;
    position: relative;
    background: linear-gradient(249.76deg, #37B55E -8.32%, #7BD3FF 108.85%), #fff;
  }

  .image {
    position: absolute;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  .image-empty {
    width: 100%;
    height: 100%;
    background-image: url('/svg/planet.svg');
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: auto;
  }

  .image-badge {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 15px;
    right: 20px;
    background-color: #F6F6F6;
    background-repeat: no-repeat;
    background-position: 7px 10px;
    border-radius: 50%;
  }

  @media screen and (max-width: 320px) {
    .image-overlay {
      height: 70vw;
    }
  }

  @media screen and (min-width: 321px) and (max-width: 570px) {
    .image-overlay {
      height: 180px;
    }
  }

  /*@media screen and (min-width: 571px) {

  }*/
</style>
